<div class="pop" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <header>
    <ng-container>
      <div class="icon" inlineSVG="sot/sot-icon.svg#sot-qrscan-ani" [setSVGAttributes]="{class: 'box-icon'}"></div>
    </ng-container>
    <h1 [langkey]="titleKey"></h1>
  </header>
  <div class="content-scan">
    <p [langkey]="infoKey"></p>
    <footer>
      <a class="btn clear" (click)="openVoucherCodeInput()"><span langkey="voucherscan_enter"></span></a>
    </footer>
    <div class="down-scan" inlineSVG="sot/sot-icon.svg#sot-down_arrows" [setSVGAttributes]="{class: 'arrows'}"></div>
  </div>
  <footer class="buttons">
    <a class="btn goback insert" (click)="cancel()">
      <div inlineSVG="sot/sot-icon.svg#sot-close" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
      <span langkey="button_cancel"></span>
    </a>
  </footer>
</div>